(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-social-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dm-social-landing')) {
  customElements.define('dm-social-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const query = selector => this.querySelector(selector);
      const dialog = query('[data-dm-popup]');
      const form = query('.dm-social__product-form');
      const select = query('[data-dm-variant]');
      const storageKey = 'dm-social-welcome-dismissed';
      const saved = () => { try { return localStorage.getItem(storageKey) === 'yes'; } catch { return false; } };
      const save = () => { try { localStorage.setItem(storageKey, 'yes'); } catch {} };
      let suppressed = saved() || this.dataset.popupAllowed !== 'true';
      let shown = false;
      let elapsed = false;
      let scrolled = false;
      const close = () => { if (dialog?.open) dialog.close(); suppressed = true; save(); };
      const show = () => { if (dialog && !dialog.open && !document.querySelector('dialog[open]')) dialog.showModal(); };
      const maybeShow = () => {
        if (!dialog || this.dataset.designMode === 'true' || this.dataset.popupEnabled !== 'true') return;
        if (elapsed && scrolled && !suppressed && !shown && document.visibilityState === 'visible') { shown = true; show(); }
      };
      if (dialog) {
        this.querySelectorAll('[data-dm-close]').forEach(button => button.addEventListener('click', close, { signal }));
        dialog.addEventListener('cancel', () => { suppressed = true; save(); }, { signal });
        dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); } }, { signal });
        query('[data-dm-preview]')?.addEventListener('click', show, { signal });
        if (query('[data-dm-signup-success]')) { suppressed = true; save(); show(); }
        if (query('[data-dm-newsletter-error]')) show();
        this.timer = setTimeout(() => { elapsed = true; maybeShow(); }, Math.max(5, Number(this.dataset.popupDelay) || 25) * 1000);
        window.addEventListener('scroll', () => { const height = document.documentElement.scrollHeight - window.innerHeight; if (height > 0 && window.scrollY / height >= Number(this.dataset.popupScroll) / 100) scrolled = true; maybeShow(); }, { passive: true, signal });
        document.addEventListener('visibilitychange', maybeShow, { signal });
      }
      form?.addEventListener('submit', () => { suppressed = true; save(); if (dialog?.open) dialog.close(); }, { signal });
      const updateVariant = () => {
        if (!select) return;
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-dm-price]').forEach(node => { node.innerHTML = option.dataset.price; });
        this.querySelectorAll('[data-dm-buy]').forEach(button => {
          button.disabled = !available;
          const label = button.querySelector('[data-dm-buy-label]');
          if (label) label.textContent = query(!available ? '[data-dm-sold-label]' : button.type === 'submit' && button.name === 'add' ? '[data-dm-add-label]' : '[data-dm-try-label]').textContent;
        });
        const quantity = form.querySelector('[name=quantity]');
        quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
        quantity.value = quantity.min;
      };
      select?.addEventListener('change', updateVariant, { signal });
      updateVariant();
    }
    disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); this.querySelector('dialog[open]')?.close(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
